export default __webpack_public_path__ + "static/media/current_class.2d67a578.svg";